import { BaseDto } from 'src/dtos/common/baseDto';

/** 일일근태 저장 필드와 그리드 편집 상태이다. */
export interface HrmAttendDailyDto extends BaseDto {
    empNo: string; // 사원번호
    workDt: string; // 출근일 기준 근무일자
    compCd: string; // 사업장코드
    shiftCd: string; // 그날의 근무조코드
    attendCd: string; // 근태코드
    startTime: string; // 출근 시각
    endTime: string; // 퇴근 시각
    lateMin: number; // 지각 분
    earlyMin: number; // 조퇴 분
    outHours: number; // 근무 제외 외출 시간
    pubOutHours: number; // 근무 인정 공용외출 시간
    breakHours: number; // 근무 제외 휴게 시간
    workHours: number; // 정상 근무시간
    overHours: number; // 연장 근무시간
    nightHours: number; // 야간 근무시간
    holidayHours: number; // 휴일 근무시간
    remark: string; // 비고
    inserted: boolean; // 신규 행이면 true
    isModified: boolean; // 편집된 행이면 true
}

/** 신규 일일근태 행의 기본값이다. */
export const defaultHrmAttendDailyDto: HrmAttendDailyDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    empNo: '', workDt: '', compCd: '', shiftCd: '', attendCd: 'A01',
    startTime: '', endTime: '', lateMin: 0, earlyMin: 0,
    outHours: 0, pubOutHours: 0, breakHours: 0, workHours: 0,
    overHours: 0, nightHours: 0, holidayHours: 0, remark: '',
    inserted: false, isModified: false,
};
